import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'miq-outdated-records-alert',
  templateUrl: './outdated-records-alert.component.html',
  styleUrls: ['./outdated-records-alert.component.scss'],
  standalone: false,
})
export class OutdatedRecordsAlertComponent implements OnInit, OnDestroy {
  constructor(
    private dialogRef: MatDialogRef<OutdatedRecordsAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public context: string
  ) {}

  ngOnInit() {
    /* required for static lable translation */
  }

  onClose() {
    this.dialogRef.close();
  }

  onUpdate() {
    this.dialogRef.close('update');
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
